import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const shelfStatsItemSchema = z.object({
  date: z.string(),
  rollup_type: z.enum(["page_1", "above_fold"]),
  position_avg: z.number().optional(),
  share_of_shelf: z.number().optional(),
  org_share_of_shelf: z.number().optional(),
  share_of_voice: z.number().optional(),
});

export const shelfStatsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getShelfStats",
    method: "get",
    path: "/shelf_stats",
    parameters: [
      { name: "stats_by", type: "Query", schema: z.string() },
      { name: "start", type: "Query", schema: z.string() },
      { name: "end", type: "Query", schema: z.string() },
      { name: "period", type: "Query", schema: z.enum(["daily", "weekly", "monthly"]) },
    ],
    status: 200,
    response: z.array(shelfStatsItemSchema),
  }).build(),
);
